import FontAwesomeIcon from "./FontAwesomeIcon";

export default function DownloadIcon({ ...props }) {
  return <FontAwesomeIcon name="download" {...props} />;
}
